import React from "react";
const EmptyState = ({ iconClass, title, subtitle , height }) => (
  <div className="d-flex flex-column align-items-center justify-content-center text-muted p-4" style={{ minHeight:height}}>
    <i className={`bi ${iconClass} mb-3`} style={{ fontSize: '2rem' }}></i>
    <h6 className="mb-1">{title}</h6>
    <small>{subtitle}</small>
  </div>
);

export default EmptyState;